module.exports = __webpack_public_path__ + "static/media/ArialCE.3508db90.ttf";